import { RouteFactory } from "@app/routePaths";
import uobLogo from "@assets/logo-uob-blue.png";
import aseanBusinessLogo from "@assets/verticals/asean-logo-black.svg";
import Ad from "@components/Advertisement/Ad";
import SectionMasthead from "@components/SectionMasthead/SectionMasthead";

export default function AseanBanner(): React.ReactElement {
  return (
    <>
      <div className="flex w-full flex-wrap items-center justify-center gap-2 pb-2 md:justify-between">
        <SectionMasthead
          link={RouteFactory.aseanBusiness}
          masthead={{
            alt: "Asean Business logo",
            src: aseanBusinessLogo,
            width: 240,
            height: 57,
          }}
        />
        <div className="block h-[1px] w-full bg-gray-850 md:hidden "></div>
        <div className="flex items-center justify-end gap-x-4">
          <span className="font-poppins text-4xs font-light">SPONSORED BY</span>
          <img src={uobLogo} alt="UOB logo" className="w-[5rem]" width="90" />
        </div>
      </div>
      <div className="mb-5 hidden h-[1px] w-full bg-gray-850 md:block "></div>

      <Ad
        adType="lb1"
        className="flex min-h-[90px] flex-col items-center justify-center pb-6"
      />
    </>
  );
}
